import { declareVconsoleComponent } from '/vodalys/vvuejs/declareVconsoleComponent.mjs'

import TranscriptVVod from './TranscriptVVod.vue'

declareVconsoleComponent('transcriptVVod', TranscriptVVod, 'transcript:vvod')